import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';

import VideoCreate from './create';
import VideoList from './list';
import VideoShow from './show';
import VideoEdit from './edit';

export default {
    create: VideoCreate,
    list: VideoList,
    show: VideoShow,
    edit: VideoEdit,
    icon: VideoLibraryIcon
};